import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0ce1c24e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "member-selector-box" }

import { ref, watchEffect } from 'vue'
import { useAsyncState } from '@vueuse/core'
import { useUserStore } from '@/store/user'
import { loadUIkitComponent } from '@/utils/loadComponent'
import Icon from '@teams/common/components/icon'

interface Emits {
  (e: 'update:visiable', visiable: boolean): void
  (e: 'cancel'): void
  (e: 'selected', members: []): void
  (e: 'close'): void
}

export default /*#__PURE__*/_defineComponent({
  __name: 'memberSelectorDialog',
  props: {
    disableUserList: null,
    single: { type: Boolean },
    onConfirm: null,
    sources: null
  },
  emits: ["update:visiable", "cancel", "selected", "close"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:visiable', visiable: boolean): void
  (e: 'cancel'): void
  (e: 'selected', members: []): void
  (e: 'close'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  disableUserList?: { userid: number }[]
  single?: boolean
  onConfirm?: (params) => Promise<void>
  sources?: Array<object>
}



const container = ref<HTMLDivElement | null>()
const userStore = useUserStore()

const { state, isReady } = useAsyncState(
  loadUIkitComponent('@uikit/vue-member').then(t => {
    return { component: t.default }
  }),
  { component: null }
)

watchEffect(() => {
  if (isReady.value) {
    const createFactory = state.value.component.create
    const MemberSelector = createFactory({
      _from: 'teams',
      _function: 'add',
      emptyTitle: '暂无可选成员',
      sources: props.sources || [
        { type: 'latest' },
        userStore.isCompanyAccount
          ? {
              type: 'company'
            }
          : {
              type: 'contact'
            }
      ],
      disableItems: props.disableUserList || [],
      single: props.single,
      onConfirm: params => {
        if (props.onConfirm) {
          // 自定义确认时执行的函数
          props.onConfirm(params.items)
        } else {
          emit('selected', params.items)
          emit('close')
        }
      },
      onCancel() {
        emit('close')
      }
    })
    MemberSelector.$mount(container.value)
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "member-selector-box__close-icon",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
    }, [
      _createVNode(_unref(Icon), {
        name: "close",
        size: 16
      })
    ]),
    _createElementVNode("div", {
      ref_key: "container",
      ref: container
    }, null, 512)
  ]))
}
}

})